var generic = generic || {};
var site = site || {};
var POWERREVIEWS = POWERREVIEWS || '';

site.offer = site.offer || {};
site.offer.ui = site.offer.ui || {};
site.sop = site.sop || {};

site.Sop = function (context) {
  this.init(context);
};

site.Sop.prototype = {
  $el: $(), // sop
  $selection: $(),
  offercode: '',
  offerData: {},
  transData: 0,
  eventCount: 0,
  skus: '',
  multiSkuView: 0,
  productData: {},
  selectedSku: '',
  appliedSku: '',
  appliedSkus: [],
  sampleAdded: 0,
  soldOutSkus: 0,
  soldOut: 0,
  maxSamplesLimit: 1,
  multipleSamplesSupport: 0,
  sampleData: {},
  $loader: $(),
  $template: $(),
  $button: $(),
  $checkboxes: $(),
  $overlay: $(),
  $anchor: $(),
  $skuDescriptionWrapper: $(),
  $accordionHeader: $(),
  defaultSkuId: null,
  // 1 Active, 2 Temporarily out of stock, 3 Coming Soon, 4 Do Not Display,
  // 5 Inactive, 6 Free Promo, 7 Sold Out, 8 Pre Order. An allowlist, so an
  // unrecognised or newly added status is treated as unavailable rather than
  // silently becoming purchasable.
  addableInventoryStatuses: [1, 6],
  isOfferChoice: function (sku) {
    var self = this;
    var code = sku && sku.PRODUCT_CODE;

    // productData.skus is fetched as the offer choices plus any linked
    // full-size SKUs, so an Active full-size SKU must not make an offer whose
    // own choices are all unavailable look available. self.skus is the
    // choices. Unrecognised shapes are left alone rather than excluded, so a
    // surprise here cannot mark a whole offer sold out.
    if (!code || !Array.isArray(self.skus)) {
      return true;
    }

    return self.skus.indexOf(code) !== -1;
  },
  isSkuAddable: function (sku) {
    var status = sku && sku.INVENTORY_STATUS;

    return status != null && this.addableInventoryStatuses.indexOf(status) !== -1;
  },
  updateAddButtonState: function (selectedSkuData) {
    var self = this;

    self.$button.removeClass('offer__soldout');
    // A SKU whose record cannot be resolved is left alone rather than disabled,
    // so a lookup miss cannot block an otherwise valid offer.
    if (selectedSkuData && !self.isSkuAddable(selectedSkuData)) {
      self.$button.addClass('offer__soldout').attr('disabled', 'disabled');
    }
  },
  checkInventory: function (productData) {
    var self = this;
    var skus = productData.skus;

    var offerChoiceCount = 0;

    $(skus).each(function (index, sku) {
      if (!self.isOfferChoice(this)) {
        // Marked unavailable so the selection fallback cannot land on a
        // full-size SKU, but not counted toward whether the offer is sold out.
        this['inventory'] = 0;

        return;
      }
      offerChoiceCount++;
      if (!self.isSkuAddable(this)) {
        this['inventory'] = 0;
        self.soldOutSkus++;
      } else {
        this['inventory'] = 1;
      }
    });
    if (offerChoiceCount > 0 && self.soldOutSkus === offerChoiceCount) {
      self.soldOut = 1;
    }
    self.multiSkuView = skus.length === 1 ? 0 : 1;
    self.checkCart(productData);
    self.renderView(productData);
  },
  renderView: function (productData) {
    var self = this;
    var vtoSkus;
    var fullSizeSkuId;
    var matchingSku;
    var $vtoButton;
    var $shadeTemplate;
    var $vtoShadeSelection;
    var sortedSkus;

    self.productData = productData;

    var defaultSku = productData.skus.find(function(sku) { return sku.PRODUCT_CODE === self.defaultSkuId });
    var appliedSku = productData.skus.find(function(sku) { return sku.PRODUCT_CODE === self.appliedSku });
    var selectedSku = appliedSku || defaultSku;
    if (self.multiSkuView) {
      self.$template = $('script.inline-template[path="offer_selection"]').html();
      var skus = productData.skus;
      var indexOfDefaultSku = skus.indexOf(defaultSku);
      skus.splice(indexOfDefaultSku, 1);
      skus.unshift(defaultSku);

      skus = skus.sort((a, b) =>
        (a.SHADENAME || '').trim().localeCompare((b.SHADENAME || '').trim())
      );

      sortedSkus = skus.slice().sort(function (a, b) {
        return (
          (a.INVENTORY_STATUS === 7) - (b.INVENTORY_STATUS === 7) ||
          (a.INVENTORY_STATUS === 2) - (b.INVENTORY_STATUS === 2) ||
          (a.INVENTORY_STATUS === 3) - (b.INVENTORY_STATUS === 3) ||
          (a.INVENTORY_STATUS === 1) - (b.INVENTORY_STATUS === 1)
        );
      });
      skus = sortedSkus;
      selectedSku = selectedSku?.INVENTORY_STATUS !== 7 ? selectedSku : skus[0];

      if (!selectedSku) {
        return;
      }
      self.selectedSku = selectedSku.PRODUCT_CODE;
      var skuMeta = self.$el.data('sku-meta');
      var allHex = [];
      vtoSkus = {};
      vtoSkus.skus = [];

      var skusForDropdown = (skus || []).filter(function (sku) {
        return skuMeta[sku.PRODUCT_CODE] &&
               sku.INVENTORY_STATUS !== 4 &&
               sku.INVENTORY_STATUS !== 5;
      }).map(function (sku) {
        var singleSkuMeta = skuMeta[sku.PRODUCT_CODE];
        var inventoryStatus = self.isSkuAddable(sku) ? 'promo-active' : 'promo-sold-out';

        if (singleSkuMeta && Array.isArray(self.productData?.skus)) {
          fullSizeSkuId = singleSkuMeta.full_size_sku_id;

          if (fullSizeSkuId) {
            matchingSku = self.productData.skus.find((item) => item.PRODUCT_CODE === fullSizeSkuId);
            if (matchingSku) {
              // Prevent duplicate SKUs in vtoSkus.skus
              if (!vtoSkus.skus.some((vSku) => vSku.PRODUCT_CODE === fullSizeSkuId)) {
                vtoSkus.skus.push(matchingSku);
              }

              // Set data-product-id if not already set
              $vtoButton = $('.js-vto-add-to-cart', self.$el);
              if (!$vtoButton.attr('data-product-id')) {
                $vtoButton.attr('data-product-id', matchingSku.PRODUCT_ID);
              }
            }
          }
        }

        if (sku.HEX_VALUE_STRING) {
          allHex.push({
            skuId: sku.PRODUCT_CODE,
            hexValue: sku.HEX_VALUE_STRING,
            inventoryStatus: inventoryStatus,
            fullSizeSkuId: fullSizeSkuId
          });
        }

        return {
          skuId: sku.PRODUCT_CODE,
          fullSizeSkuId: fullSizeSkuId,
          skuName: singleSkuMeta['label'] || sku.PRODUCT_SIZE || sku.SHADENAME,
          inventoryStatus: inventoryStatus,
          hex: sku.HEX_VALUE_STRING
        }
      });
      $.each(allHex, function (index, hex) {
        $colorbox = $('<div>')
          .addClass('color-box js-color-box ' + hex.inventoryStatus)
          .css('background-color', hex.hexValue)
          .attr('data-color', hex.hexValue)
          .attr('data-sku-id', hex.skuId)
          .attr('data-full-size-sku-id', hex.fullSizeSkuId);
        if (self.selectedSku === hex.skuId) {
          $colorbox.addClass('selected');
        }
        $colorbox.appendTo('.js-pwp-product-hex-grid');
      });
      if (allHex.length > 22) {
        self.$el.find('.pwp-product-hex-grid-toggle-container').show()
      }
      var selectedSkuMeta = skuMeta[selectedSku.PRODUCT_CODE];

      self.$selection = Mustache.render(self.$template, {
        skus: skusForDropdown,
        SELECTED_SIZE: selectedSkuMeta['label'] || selectedSku.PRODUCT_SIZE || selectedSku.SHADENAME,
        SELECTED_SKU: selectedSku.PRODUCT_CODE,
        SELECTED_HEX: selectedSku.HEX_VALUE_STRING
      });

      $('.js-pwp-product-offer-selection__dropdown', self.$el).append(self.$selection);
      self.filterCarousel(self.selectedSku);
      self.vtoShadeLoad();
    }
    self.displayPrice(selectedSku);
    self.$el.addClass('offer__loaded');
    self.getDom();
  },
  vtoShadeLoad: function () {
    var self = this;
    var vtoFullSizeSkus = { skus: [] };
    var $vtoButton = $('.js-product-foundation-vto-btn', self.$el);
    var $vtoAddToCart = $('.js-vto-add-to-cart', self.$el);
    var $shadeTemplate;
    var fullSizeProductId = $vtoAddToCart.attr('data-product-id');
    var fullSizeProduct;
    var fullSizeSkus;
    var $vtoShadeSelection;

    if (fullSizeProductId) {
      var params = {
        query_key: 'catalog-spp',
        products: [fullSizeProductId]
      };
      generic.jsonrpc.fetch({
        method: 'prodcat.querykey',
        params: [params],
        onSuccess: function (response) {
          fullSizeProduct = response.getValue();

          if (
            fullSizeProduct &&
            fullSizeProduct.products &&
            fullSizeProduct.products.length
          ) {
            fullSizeSkus = fullSizeProduct.products[0].skus || [];

            fullSizeSkus
              .filter(sku => sku && sku.SHADENAME)
              .sort((a, b) => a.SHADENAME.localeCompare(b.SHADENAME))
              .forEach(vSku => vtoFullSizeSkus.skus.push(vSku));

            $shadeTemplate = $('script.inline-template[path="gwp_foundation-vto"]').html();
            $vtoShadeSelection = Mustache.render($shadeTemplate, vtoFullSizeSkus);
            $('.js-product-foundation-shade-container', self.$el)
              .prepend($vtoShadeSelection);
            page_data.fullSizeSkus = vtoFullSizeSkus.skus;
            Drupal.behaviors.productFoundationVtov2.attach($(document));
            $vtoButton.removeClass('hidden');
          }
        }
      });
    }
  },
  displayPrice: function (selectedSku) {
    var self = this;
    var isOnSale = selectedSku.PRICE2 && selectedSku.formattedPrice !== selectedSku.formattedPrice2;
    self.$priceTemplate = $('script.inline-template[path="sku_price"]').html();
    if (selectedSku.PRICE > 0) {
      var priceRendered = Mustache.render(self.$priceTemplate, {
        isOnSale: isOnSale,
        salePrice: selectedSku.formattedPrice,
        originalPrice: isOnSale ? selectedSku.formattedPrice2 : selectedSku.formattedPrice
      });
      $('.js-pwp-product-offer-selection__price', self.$el).html(priceRendered);
    } else {
      $('.js-pwp-product-offer-selection__price', self.$el).html('');
    }
  },
  checkCart: function (productData) {
    var self = this;

    self.appliedSkus = [];

    // is item already in cart?
    if (self.transData?.order?.samples) {
      $.each(self.transData.order.samples, function (index, sample) {
        if (sample.OFFER_CODE === self.offercode) {
          var appliedSkuId = sample['sku.SKU_ID'];
          var appliedSku = productData.skus.find(function(sku) { return sku.SKU_ID === appliedSkuId });
          var skuMeta = self.$el.data('sku-meta');
          if (appliedSku && skuMeta[appliedSku.PRODUCT_CODE]) {
            self.appliedSku = appliedSku.PRODUCT_CODE;
            self.appliedSkus.push(appliedSku.PRODUCT_CODE);
          }
        }
      });
    }
  },
  getDom: function () {
    var self = this;

    self.$loader = $('.js-product-full__loader', self.$el);
    self.$button = $('.js-pwp-product__add-button', self.$el);
    self.$vtoAddToCartButton = $('.js-vto-add-to-cart', self.$el);
    self.$selection = $('.js-product-full__offer', self.$el);
    self.$offerSelection = $('.js-offer-selection', self.$el);
    self.$checkboxes = $('.js-offer__selections__checkbox', self.$selection);
    self.$overlay = $('.js-product-full__offer__success', self.$el).html();
    self.$skuDescriptionWrapper = $('.js-pwp-product-offer-selection__description', self.$el);
    self.$skuDescriptionWrapper.find('[data-sku-id="'+self.selectedSku+'"]').removeClass('hidden');
    self.$skuColorBox = $('.js-pwp-product-hex-grid', self.$el);
    self.addEvents();
  },
  addEvents: function () {
    var self = this;

    if(!self.multiSkuView) {
      self.$skuDescriptionWrapper.hide();
    }

    self.cartSampleLoaded();

    if (self.appliedSku.length) {
      self.appliedState(1);
    } else {
      self.$loader.addClass('hidden');
      if (self.soldOut) {
        self.$button.addClass('offer__soldout');
        return;
      }
      $.each(self.productData.skus, function (index, el) {
        if (this['inventory'] != 0) {
          self.selectedSku = this.PRODUCT_CODE;
          return false;
        }
      });
    }
    self.$button.attr('data-sku-id', self.selectedSku);

    if (self.multiSkuView) {
      self.$offerSelection.click(function () {
        $(this).attr('tabindex', 1).focus()
        .toggleClass('active')
        .find('.offer-selection__dropdown-menu').toggle();
      });
      self.$offerSelection.focusout(function () {
        setTimeout(() => { $(this)
        .removeClass('active')
        .find('.offer-selection__dropdown-menu').hide();
        }, 100)
      });
      $('.offer-selection__dropdown-menu li').on('click', function (e) {
        e.preventDefault();
        var $currentLi = $(this);
        var skuId = $currentLi.attr('data-sku-id');
        self.selectSku(skuId, $currentLi);
      });

      self.$el.find('.color-box').on('click', function (e) {
        e.preventDefault();
        const skuId = $(this).attr('data-sku-id');
        const $correspondingLi = $(`.offer-selection__dropdown-menu li[data-sku-id="${skuId}"]`);
        if ($correspondingLi.length) {
            self.selectSku(skuId, $correspondingLi);
        }
      });

      var $initialColorBox = $('.js-color-box.selected', self.$el).first();

      $initialColorBox.trigger('click');

      // Where the offer renders as a dropdown there are no color boxes, so the
      // trigger above does nothing and selectSku never runs on load. The block
      // further up may also have moved selectedSku to the first available SKU,
      // which leaves the label, price and description showing the original
      // default while the button carries a different one. Running selectSku
      // puts all of them on the same SKU.
      if (!$initialColorBox.length) {
        var $selectedOption = $(`.offer-selection__dropdown-menu li[data-sku-id="${self.selectedSku}"]`);

        if ($selectedOption.length) {
          self.selectSku(self.selectedSku, $selectedOption);
        } else {
          self.updateAddButtonState(
            (self.productData.skus || []).find(function (sku) {
              return sku.PRODUCT_CODE === self.selectedSku;
            })
          );
        }
      }

      // Toggle buttons
      $('.pwp-product-hex-grid-toggle__show').on('click', function() {
        $('.pwp-product-hex-grid').addClass('expanded');
        $(this).hide();
        $('.pwp-product-hex-grid-toggle__collapse').show();
      });

      $('.pwp-product-hex-grid-toggle__collapse').on('click', function() {
          $('.pwp-product-hex-grid').removeClass('expanded');
          $(this).hide();
          $('.pwp-product-hex-grid-toggle__show').show();
      });
    }

    // add offer
    self.$button.on('click', function (event) {
      event.preventDefault();
      var productCode = $(this).attr('data-sku-id');
      var offerAppliedSkus = [];
      var skuId = self.productData.skus.find(function(sku) { return sku.PRODUCT_CODE === productCode }).SKU_ID;

      if (self.multipleSamplesSupport) {
        offerAppliedSkus = self.checkMaxNoSamples(skuId);

        if (offerAppliedSkus.length) {
          skuId = offerAppliedSkus.join(',');
        }
      }
      site.offer.ui.applyOffer(self.offercode, skuId);
      // add loading class
      self.$loader.removeClass('hidden');
    });
  },
  cartSampleLoaded: function () {
    var self = this;

    if (Number(self.$button.attr('data-max-no-samples')) > 1) {
      self.maxSamplesLimit = Number(self.$button.attr('data-max-no-samples'));
      self.multipleSamplesSupport = 1;
    }

    if (self.multipleSamplesSupport && self.appliedSkus.length) {
      self.appliedSkus.forEach((val) => {
        const $selectedBox = self.$el.find(`.color-box[data-sku-id="${val}"]`);

        if ($selectedBox.length) {
          if (self.sampleAdded >= self.maxSamplesLimit) {
            self.sampleAdded = 0;
          }

          self.sampleAdded++;

          // Clear old markers
          self.$el.find('.color-box').removeClass('last-added');
          self.$el.find(`.sample-added-${self.sampleAdded}`).removeClass(`sample-added-${self.sampleAdded}`);

          // Mark current selection
          $selectedBox.addClass(`sample-added-${self.sampleAdded} last-added`);
        }
      });
    }
  },
  checkMaxNoSamples: function (skuId) {
    var self = this;
    var offerAppliedSkus = [];
    var samples = self?.sampleData?.order?.samples;

    if (Array.isArray(samples)) {
      samples.forEach(function (sample) {
        if (sample.OFFER_CODE === self.offercode) {
          offerAppliedSkus.push(sample['sku.SKU_ID']);
        }
      });
    }

    // Ensure we only add if not already in applied list
    if (
      self.multipleSamplesSupport &&
      !offerAppliedSkus.includes(skuId)
    ) {
      if (offerAppliedSkus.length === self.maxSamplesLimit) {
        // Remove the first non "last-added" SKU if found
        for (let i = 0; i < offerAppliedSkus.length; i++) {
          const sku = offerAppliedSkus[i];
          var selectedSkuData = self.productData.skus.find(function (skuItem) {
            return skuItem.SKU_ID === sku;
          });
          const $box = self.$el.find(`.color-box[data-sku-id="${selectedSkuData.PRODUCT_CODE}"]`);

          if ($box.length > 0 && !$box.hasClass('last-added') && $box.hasClass('sample-added-1')) {
            // Remove exact match
            offerAppliedSkus.splice(i, 1);
            $box.removeClass('sample-added-1');
            break;
          }
        }

        // If still at max, remove the oldest one (FIFO style)
        if (offerAppliedSkus.length === self.maxSamplesLimit) {
          offerAppliedSkus.shift();
        }
      }

      // Finally add the new SKU
      offerAppliedSkus.push(skuId);
    }

    return offerAppliedSkus;
  },
  selectSku: function (skuId, $element) {
    var self = this;
    self.selectedSku = skuId;
    var selectedSkuData = self.productData.skus.find(function (sku) { return sku.PRODUCT_CODE === skuId });
    self.displayPrice(selectedSkuData);
    self.$button.attr('data-sku-id', skuId);
    if (self.selectedSku === self.appliedSku
      || (self.multipleSamplesSupport && Array.isArray(self.appliedSkus)
      && $.inArray(self.selectedSku, self.appliedSkus) !== -1)) {
      self.$vtoAddToCartButton.attr('disabled', 'disabled');
      self.$button.addClass('offer__applied').attr('disabled', 'disabled');
    } else {
      self.$vtoAddToCartButton.removeAttr('disabled');
      self.$button.removeClass('offer__applied').removeAttr('disabled');
    }
    self.updateAddButtonState(selectedSkuData);

    self.filterCarousel(self.selectedSku);
    self.$offerSelection.find('.js-offer-selection__select').html($element.html());
    self.$skuDescriptionWrapper
      .find('.pwp-product-offer-selection__description-text')
      .addClass('hidden');
    self.$skuDescriptionWrapper.find(`[data-sku-id="${self.selectedSku}"]`).removeClass('hidden');
    // Update color grid
    self.$el.find('.color-box').removeClass('selected');
    var $colorbox = self.$el.find(`.color-box[data-sku-id="${skuId}"]`);
    $colorbox.addClass('selected');
    $colorbox.removeClass('offer__applied');
    if (self.multipleSamplesSupport && Array.isArray(self.appliedSkus)
      && $.inArray(self.selectedSku, self.appliedSkus) !== -1) {
      $colorbox.addClass('offer__applied');
    }
    if ($colorbox[0]) {
      $colorbox[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
  isSkuApplied: function (skudId) {
    var self = this;
    var isApplied = false;

    if (!skudId || !self.transData) {
      return false;
    }
    // is item alredy in cart?
    if (self.transData) {
      $.each(self.transData.order.samples, function (index, sample) {
        if (sample.OFFER_CODE === self.offercode) {
          if (sample['sku.PRODUCT_CODE'] === skudId) {
            isApplied = true;
          }
        }
      });
    }

    return isApplied;
  },
  appliedState: function (state) {
    var self = this;

    if (state) {
      self.$loader.addClass('hidden');
      self.$button.addClass('offer__applied').attr('disabled', 'disabled');
      self.$vtoAddToCartButton.attr('disabled', 'disabled');
      if (self.selectedSku.length) {
        self.appliedSku = self.selectedSku;

        const $selectedBox = self.$el.find(`.color-box[data-sku-id="${self.selectedSku}"]`);

        if (self.multipleSamplesSupport && $selectedBox.length && !$selectedBox.is('[class*="sample-added-"]')) {
          if (self.sampleAdded >= self.maxSamplesLimit) {
            $('div[class*="sample-added-"]').each(function() {
              const match = $(this).attr('class').match(/sample-added-(\d+)/);
              if (match) {
                let num = parseInt(match[1], 10);
                if (num > 1) {
                  $(this).removeClass(`sample-added-${num}`).addClass(`sample-added-${num - 1}`);
                }
              }
            });
          } else {
            self.sampleAdded++;
          }
          self.$el.find('.color-box').removeClass('last-added');
          self.$el.find(`.sample-added-${self.sampleAdded}`).removeClass(`sample-added-${self.sampleAdded}`);
          $selectedBox.addClass(`sample-added-${self.sampleAdded} last-added`);
        }
      }

      if (self.multipleSamplesSupport) {
        self.appliedShadeSku();
      }
    } else {
      self.$button.removeClass('offer__applied').removeAttr('disabled');
      self.$vtoAddToCartButton.removeAttr('disabled');
    }
  },
  appliedShadeSku: function () {
    var self = this;

    if (Array.isArray(self.appliedSkus) && self.appliedSkus.length) {
      const skuMeta = self.$el.data('sku-meta');

      // Clear old highlights
      self.$el.find('.color-box').removeClass('offer__applied');

      // Build selector for new ones
      const selectors = self.appliedSkus
        .filter((skuId) => (skuId && skuMeta[skuId]))
        .map((skuId) => (`.color-box[data-sku-id="${skuId}"]`))
        .join(',');

      if (selectors) {
        self.$el.find(selectors).addClass('offer__applied');
      }
    }
  },
  successOverlay: function () {
    var self = this;

    generic.overlay.launch({
      content: self.$overlay,
      includeCloseLink: true,
      cssClass: 'sop--v2__success-popup',
      includeBackground: true,
    });
    self.cartRefresh();
  },
  cartRefresh: function () {
    var cartEvent = new CustomEvent('fetchCartDrawer');

    // Dispatch locally
    window.dispatchEvent(cartEvent);

    // Try to dispatch to parent safely
    try {
      if (window.parent && window.parent !== window) {
        window.parent.dispatchEvent(cartEvent);
      }
    } catch (err) {
      console.warn('Could not dispatch fetchCartDrawer event to parent frame:', err);
    }
  },
  listeners: function () {
    var self = this;
    var offerLoaded = 'offerData:' + self.offercode + ':loaded';
    var dualLoaded = offerLoaded + ' transData:loaded';
    var full_size_skus;
    var skuMeta;
    var combine_skus;

    // listen for loaded data
    $(document).on(dualLoaded, function (event, data) {
      if (event.type === offerLoaded) {
        self.offerData = data;
        self.eventCount++;
      } else if (event.type === 'transData:loaded') {
        self.transData = data;
        self.eventCount++;
      }
      if (self.eventCount === 2) {
        $.each(self.offerData.benefits, function (idx, benefit) {
          if (benefit.choices) {
            self.skus = benefit.choices;
          }
        });
        full_size_skus = [];
        skuMeta = self.$el.data('sku-meta') || {};

        Object.values(skuMeta).forEach((value) => {
          if (value && value.full_size_sku_id) {
            full_size_skus.push(value.full_size_sku_id);
          }
        });
        combine_skus = [... self.skus, ... full_size_skus];

        site.offer.ui.getProductData(combine_skus, self.offercode);
      }
    });

    $(document).on('skus:' + self.offercode + ':loaded', function (event, productData) {
      if (productData && Array.isArray(productData.skus)) {
        productData.skus = productData.skus.filter(Boolean);
      }

      productData.skus = productData.skus.filter(function (sku) {
        return sku.INVENTORY_STATUS !== 4 &&
               sku.INVENTORY_STATUS !== 5;
      });

      self.checkInventory(productData);
      if (productData?.skus && page_data) {
        page_data.skus = productData.skus;
      }
      if (self.multipleSamplesSupport) {
        self.getSampleData();
      }
    });

    $(document).on('offer:' + self.offercode + ':applied', function (event, response) {
      self.appliedState(1);
      self.successOverlay();
      if (self.multipleSamplesSupport) {
        self.getSampleData();
      }
    });
  },
  getSampleData: function () {
    var self = this;

    generic.jsonrpc.fetch({
      method: 'trans.get',
      params: [
        {
          order_fields: ['samples']
        }
      ],
      onSuccess: function (jsonRpcResponse) {
        self.sampleData = jsonRpcResponse.getValue();
        var samples = self?.sampleData?.order?.samples;

        self.appliedSkus = [];

        if (Array.isArray(samples)) {
          samples.forEach(function (sample) {
            if (sample.OFFER_CODE === self.offercode) {
              var appliedSKU = self.productData.skus.find(function (sku) {
                return sku.SKU_BASE_ID === sample['sku.SKU_BASE_ID'];
              });

              if (appliedSKU?.SKU_BASE_ID) {
                self.appliedSkus.push(appliedSKU.PRODUCT_CODE);
              }
            }
          });
        }

        if (self.transData && samples) {
          self.transData.order = self.transData.order || {};
          self.transData.order.samples = samples;
        }
        self.appliedShadeSku();
      },
      onFailure: function () {
        console.error('Transaction JSON failed to load');
      }
    });
  },
  filterCarousel: function (skuId) {
    var self = this;
    $('.js-carousel-thumbnails', self.$el).slick('slickUnfilter');
    $('.js-slider-view-wrapper', self.$el).slick('slickUnfilter');

    $('.js-carousel-thumbnails', self.$el).slick('slickFilter', function () {
      var skuIdAttr = $(this).find('.js-product-images-wrapper, .js-video-thumbnail').attr('data-sku-id');
      return skuIdAttr === skuId || !skuIdAttr;
    });
    $(".js-carousel-thumbnails .slick-slide:not(.slick-cloned)").each(function (index, slide) {
      $(slide).attr("data-slick-index", index);
    });
    $('.js-slider-view-wrapper', self.$el).slick('slickFilter', function () {
      var skuIdAttr = $(this).find('.js-image-slider-images-wrapper').attr('data-sku-id');
      return skuIdAttr === skuId || !skuIdAttr;
    });
    $(".js-slider-view-wrapper .slick-slide:not(.slick-cloned)").each(function (index, slide) {
      $(slide).attr("data-slick-index", index);
    });

    $('.js-carousel-thumbnails', self.$el).slick('slickGoTo', 0);
  },
  headerHeight: function () {
    // similar to Drupal.ELB.ui.header_height();
    // avoiding global change due to impact
    var toolbarHeight = $('#toolbar').height();
    var pageHeaderHeight = $('.page-header').outerHeight();

    if ($('#toolbar').hasClass('mobile')) {
      var searchHeight = $('.el-mobile-search-block').outerHeight();

      // toolbar always has height on mobile
      // subtract search bar in case sticky header is in play
      return pageHeaderHeight - searchHeight;
    } else {
      return toolbarHeight + pageHeaderHeight;
    }
  },
  startSlider: function () {
    var self = this;
    var hoverZoomConfig = '';

    if (typeof Drupal.settings.elc_ecom.prodcatConfig.hoverZoom !== 'undefined' && typeof Drupal.settings.elc_ecom.prodcatConfig.hoverZoom.enabled !== 'undefined') {
      hoverZoomConfig = Drupal.settings.elc_ecom.prodcatConfig.hoverZoom;
    }
    $('.js-carousel-section-wrapper', this.$el).each(function () {
      var $self = $(this);
      var fullImages = $('.js-slider-view-wrapper', this.$el).find('.js-image-slider-images-wrapper');
      var firstImageNaturalWidth = $(fullImages[0]).find('img')[0].naturalWidth;

      $('.js-carousel-thumbnails', $self)
        .slick({
          vertical: true,
          arrows: true,
          infinite: true,
          slidesToShow: 5,
          focusOnSelect: true,
          speed: 300,
          slidesToScroll: 1,
          prevArrow:
            '<div class="elc-slider-arrow-wrapper js-slider-arrow-wrapper slick-prev" direction="top" role="button" tabindex="0" aria-label=""><div class="elc-directional-icon elc-slider-arrow-top elc-icon js-icon"></div></div>',
          nextArrow:
            '<div class="elc-slider-arrow-wrapper js-slider-arrow-wrapper slick-next" direction="bottom" role="button" tabindex="0" aria-label=""><div class="elc-directional-icon elc-slider-arrow-bottom elc-icon js-icon"></div></div>',
          asNavFor: $('.js-slider-view-wrapper', $self)
        });

      $('.js-slider-view-wrapper', $self)
        .on('init', function () {
          $(this).css('visibility', 'visible');
        })
        .slick({
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<div class="elc-slider-arrow-wrapper js-slider-arrow-wrapper slick-prev" direction="left" role="button" tabindex="0" aria-label="Prev Slide"><div class="elc-directional-icon elc-slider-arrow-left elc-icon js-icon"></div></div>',
          nextArrow:
            '<div class="elc-slider-arrow-wrapper js-slider-arrow-wrapper slick-next" direction="right" role="button" tabindex="0" aria-label="Next Slide"><div class="elc-directional-icon elc-slider-arrow-right elc-icon js-icon"></div></div>',
          asNavFor: $('.js-carousel-thumbnails', $self)
        });

      // Init. Zoom on First Image.
      if (self.isNotMobile() && hoverZoomConfig.enabled === true) {
        let magnifyAmount = 1 + (parseInt(hoverZoomConfig.percent, 10) / 100);

        if (firstImageNaturalWidth >= hoverZoomConfig.sizeThreshold) {
          magnifyAmount = 1;
        }
        fullImages.zoom({
          magnify: magnifyAmount
        });
      }
    });

    $('.js-video-thumbnail-wrapper', this.$el).click(function () {
      var $youtubeEl = $(this).siblings('iframe.youtube-video');
      $youtubeEl.css('z-index', 100);
      $youtubeEl.get(0).contentWindow.postMessage('{"event":"command","func":"playVideo"}', '*')
    });
    $('.js-slider-view-wrapper', this.$el).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var $currentSlide = slick.$slides.eq(currentSlide);
      var $nextSlide = slick.$slides.eq(nextSlide);
      var $currentSlideImageWrapper = $currentSlide.find('.js-image-slider-images-wrapper');
      var $nextSlideImageWrapper = $nextSlide.find('.js-image-slider-images-wrapper');
      var nextSlideImageNaturalWidth = $nextSlide.find('img')[0].naturalWidth;

      if (self.isNotMobile() && hoverZoomConfig.enabled === true) {
        $currentSlideImageWrapper.trigger('zoom.destroy');
        let magnifyAmount = 1 + (parseInt(hoverZoomConfig.percent, 10) / 100);

        if (nextSlideImageNaturalWidth >= hoverZoomConfig.sizeThreshold) {
          magnifyAmount = 1;
        }
        $nextSlideImageWrapper.zoom({
          magnify: magnifyAmount
        });
      }
      $('.page-main').css('overflow-x', 'visible');

      if ($currentSlide.find('iframe.youtube-video').length > 0) {
        var $youtubeEl = $currentSlide.find('iframe.youtube-video');
        $youtubeEl.css('z-index', 0);
        $youtubeEl.get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo"}', '*')
      }
    });
  },
  initAccordion: function() {
    self.$accordionHeader = $('.js-accordion-header');
    self.$accordionHeader.on('click', function() {
      $(this).toggleClass('accordion-header--expanded');
    });
  },
  isNotMobile: function () {
    return !(('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  },
  setupReviews: function (context) {

    var pr_products = [];
    var mpp_snippet_counter = 1;
    var drupalPRSettings = Drupal.settings.analytics ? Drupal.settings.analytics.power_reviews_enh_enabled : false;
    var $productFull = $('.js-sop--v2', context);
    var $reviewsnippet = $('.review-snippet', context);
    var locales = $.cookie('LOCALE');
    var base_url = window.location.protocol + '//' + document.location.hostname;
    var $currentObject = $productFull;
    var hasProdTranslations = typeof site !== 'undefined' && typeof site.translations !== 'undefined' && typeof site.translations.elc_product !== 'undefined';

    var wrapperUrl = '';
    var signedIn = '';
    var reviewWrapperUrl = '';
    var signedReviewUrl = '';
    var pr_page_id = '';
    var image_url = '';
    var url = '';
    var product = null;
    var pr_product = null;

    if (typeof Drupal.settings.power_reviews !== 'undefined' && typeof Drupal.settings.power_reviews.signed_review_url !== 'undefined') {
      signedReviewUrl = Drupal.settings.power_reviews.signed_review_url;
    }

    if (POWERREVIEWS && typeof Drupal.settings.power_reviews !== 'undefined' && ($currentObject.data('product-id') !== '' && typeof $currentObject.data('product-id') !== 'undefined')) {

      let product_id = $currentObject.data('product-id');
      let product_base_id = typeof product_id !== 'undefined' ? product_id.substring(4) : '';
      let reviewsnippet_id = 'pr-reviewsnippet-' + product_base_id + '-' + mpp_snippet_counter + '-' + (new Date()).getTime();

      let pr_locale = document.location.href.search('francais.esteelauder.ca') > 0 ? Drupal.settings.power_reviews.locale_fr : Drupal.settings.power_reviews.locale;
      let pr_merchant_id = document.location.href.search('francais.esteelauder.ca') > 0 ? Drupal.settings.power_reviews.merchant_id_fr : Drupal.settings.power_reviews.merchant_id;
      let page_id = Drupal.settings.power_reviews.page_id || product_base_id;
      let reviewScrollOffset = 175;
      let reviewScrollDelay = 1000;

      wrapperUrl = Drupal.settings.power_reviews.review_wrapper_url;
      signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;

      if (signedReviewUrl && signedIn) {
        wrapperUrl = Drupal.settings.power_reviews.review_wrapper_url_signin;
      } else {
        wrapperUrl = Drupal.settings.power_reviews.review_wrapper_url;
      }

      reviewWrapperUrl = (wrapperUrl || '/review/create') + '?pr_page_id=' + page_id;

      $reviewsnippet.attr('id', reviewsnippet_id);

      if (locales && locales !== '') {
        locales = locales.toLowerCase();
        if (typeof Drupal.settings.power_reviews[locales] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['merchant_id'] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['locale'] !== 'undefined') {
          pr_merchant_id = Drupal.settings.power_reviews[locales]['merchant_id'];
          pr_locale = Drupal.settings.power_reviews[locales]['locale'];
        }
      }

      if (product_base_id && $reviewsnippet.length && !$reviewsnippet.hasClass('reviews-processed')) {
        $reviewsnippet.addClass('reviews-processed');
        pr_product = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: pr_locale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: pr_merchant_id,
          page_id: page_id,
          review_wrapper_url: reviewWrapperUrl,
          components: {
          }
        };

        if ($currentObject.hasClass('sop--v2')) {
          pr_product.on_read_reviews_click = function() {
            $('.js-pr-rating-tab', $('.responsive-tabs--powerreviews')).click();
            $('html, body').animate({
              'scrollTop': $('#pr-reviewdisplay').offset().top - 175
            }, 1000);
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              site.track.reviewRead();
            }
          };
          pr_product.on_write_review_click = function(config, data) {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              site.track.reviewWriteStart();
            }
            var war_link = $('.pr-snippet-write-review-link').attr('href');
            if (typeof war_link !== 'undefined' && war_link !== '') {
              window.location.href = war_link;
            }
          };
          pr_product.components.ReviewDisplay = 'pr-reviewdisplay';
          pr_product.components.ReviewSnippet = reviewsnippet_id;

          pr_product.on_render = function(config, data) {
            if (config.component === 'ReviewList' && !data.review_count && hasProdTranslations && typeof site.translations.elc_product.first_to_write_review !== 'undefined' ) {
              $('.pr-snippet-write-review-link', $('.pr-snippet-read-and-write')).text(site.translations.elc_product.first_to_write_review);
            }
            if (config.component === 'ReviewList' && data.review_count > 0 && hasProdTranslations && typeof site.translations.elc_product.read_reviews !== 'undefined' ) {
              var reviewsCountEle = '<span class="elc-reviews-number">(' + data.review_count + ')</span>' ;
              $('.pr-snippet-review-count', $('.review-snippet')).html(site.translations.elc_product.read_reviews).before(reviewsCountEle);
            }
            if (config.component === 'ReviewDisplay') {
              if ($('.js-spp-reviews-mobile').length === 0) {
                $('.pr-review-snapshot-block-cons', $('.pr-review-snapshot-block-container')).append($('.pr-review-snapshot-snippets'));
              }
            }
            $('.js-pwp-review', $currentObject).once().on('click', '.pr-snippet-stars-container, .elc-reviews-number', function() {
              $('html, body').animate({
                'scrollTop': $('#pr-reviewdisplay').offset().top - reviewScrollOffset
              }, reviewScrollDelay);
            });
            // GAPGLOBAL-1256 Analytics enhancements for read/write reviews Starts
            if (drupalPRSettings) {
              // Track sort option in reviews page
              $('#pr-rd-sort-by').once().on('change', function() {
                if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
                  var obj = {
                    sort_option: $('option:selected', this).text()
                  };
                  site.track.sortReviews(obj);
                }
              });

              // Tracking search action in review section
              $('.pr-rd-search-reviews-icon-button').once().on('click', function() {
                if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
                  var searchTerm = $(this).siblings(':input').attr('value');
                  if (searchTerm && searchTerm !== '') {
                    var obj = {
                      search_term: searchTerm
                    };
                    site.track.searchReviews(obj);
                  }
                }
              });

              // Tracking filter action in review section
              $('.pr-multiselect').once('js-multi-select').each(function() {
                var selectElement = $(this).find('.pr-multiselect-options li');
                selectElement.on('click', function() {
                  var $checkboxElem = $(this);
                  if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && !($checkboxElem.attr('data-selected') === 'selected')) {
                    $checkboxElem.attr('data-selected', 'selected');
                    var selectedFilter = selectElement.filter('[data-selected="selected"]');
                    var appliedFiltersArray = [];
                    var filter_type = '';
                    var filter_type_html = selectElement.closest('.pr-multiselect-options').siblings('.pr-multiselect-button').find('span:not(.pr-multiselect-count)');
                    filter_type_html.each(function() {
                      var filterText = $(this).text();
                      if (!!filterText && filterText.trim() !== '' && filterText.trim() !== '&nbsp;') {
                        filter_type = filterText.trim();
                      }
                    });
                    selectedFilter.each(function() {
                      appliedFiltersArray.push($(this).text());
                    });
                    var obj = {
                      sort_option: filter_type + ' | ' + appliedFiltersArray.join(', ')
                    };
                    site.track.filterReviews(obj);
                  } else if ($checkboxElem.attr('data-selected') === 'selected') {
                    $checkboxElem.attr('data-selected', 'deselected');
                  }
                });
              });
            }
          };
        } else {
          pr_product.components.CategorySnippet = reviewsnippet_id;
        }
        pr_products.push(pr_product);
      }
    }
    mpp_snippet_counter++;

    if ($productFull.length && !$productFull.hasClass('js-pr-product')) {
      $productFull.addClass('js-pr-product');
      if (!$productFull.attr('data-product-id')) {
        pr_page_id = typeof page_data['catalog-spp'] !== 'undefined' && typeof page_data['catalog-spp']['products'] !== 'undefined' && typeof page_data['catalog-spp']['products'] === 'object' ? page_data['catalog-spp']['products'][0]['PRODUCT_ID'] : '';
        $productFull.attr('data-product-id', pr_page_id);
      }
    }
    $('#BVRRSummaryContainer').addClass('review-snippet');

    if (POWERREVIEWS && typeof Drupal.settings.power_reviews !== 'undefined' && pr_products.length !== 0) {
      POWERREVIEWS.display?.render(pr_products);
    }
  },
  init: function (context) {
    var self = this;

    self.$el = $(context);
    self.offercode = self.$el.data('offer-code');
    self.listeners();
    self.offerData = site.offer.ui.getOfferData(self.offercode);
    self.transData = site.offer.ui.getTransData();
    self.defaultSkuId = self.$el.data('default-sku-id');
    self.selectedSku = self.defaultSkuId;

    self.$anchor = $('.js-product-full__detail-link', context);
    self.$anchor.click(function (event) {
      event.preventDefault();
      var headerOffset = self.headerHeight();

      $.scrollTo($('.spp-product__details').offset().top - headerOffset, 400);
    });

    self.startSlider();
    self.setupReviews();
    self.initAccordion();
  }
};

// single offer page v2
(function ($) {
  Drupal.behaviors.sop_v2 = {
    attach: function (context, settings) {
      var $container = $('.js-sop--v2', context);

      $container.each(function (index, el) {
        var sop = new site.Sop(this);
      });
    }
  };
})(jQuery);
